import { render } from "./AgendaItemPublicModal.vue?vue&type=template&id=ad139b6a&scoped=true"
import script from "./AgendaItemPublicModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AgendaItemPublicModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./AgendaItemPublicModal.vue?vue&type=style&index=0&id=ad139b6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad139b6a"]])

export default __exports__